module.exports = __webpack_public_path__ + "img/emptyImage.35707bd9.svg";